import requist from "./axios";
import https from "./axios";
import qs from "qs";
import Store from "@/store/index";
export const get_bills = uid => {
  return requist.get(`/v2/users/${uid}/bills/`);
};
export const get_myinfo = async () => {
  return requist.get("/v2/me/");
};
export const get_home = () => {
  return requist.get("/v2/home/");
};
export const get_paytype = () => {
  return requist.get("/v2/repay/channel/");
};
export const get_repayment_code = form => {
  return requist.get("/v2/repay/code/", { params: form });
};
export const get_banner = form => {
  return requist.get("/v2/features/", { params: form });
};
//terms/privacy/faq
export const get_protocol = type => {
  return requist.get(`/v2/agreement/${type}/`);
};
export const get_tkp = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).get(
    "/idn-om-agency/agency/officialWebsiteData/queryOfficialWebsiteData",
    form
  );
};
export const saveSign = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    "/idn-app-server/api/uploadSignImage",
    form
  );
};
export const getPdf = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    `/idn-app-server/api/getContractUrl?${qs.stringify(form)}`
  );
};
export const sendMessage = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    `/idn-app-server/api/sendSmsCode?${qs.stringify(form)}`
  );
};
export const verifySmsCode = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    `/idn-app-server/api/verifySmsCode`,
    form
  );
};
export const reportPoint = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    `/idn-event-tracking/event/h5/report`,
    {
      disLoading: true,
      ...form
    }
  );
};
export const hasLoanOrder = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).get(
    `/idn-app-server/api/v2/hasLoanOrder?${qs.stringify(form)}`
  );
};
export const feedBack = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    `/idn-app-server/api/v2/userCancelFeedback?${qs.stringify(form)}`
  );
};
export const queryChristmasActivityTimes = () => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    `/idn-app-server/api/v2/marketing/queryChristmasActivityTimes`
  );
};
export const userCancelOrder = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).get(
    `/idn-app-server/api/v2/userCancelOrder?${qs.stringify(form)}`
  );
};
export const christmasActivity = () => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    `/idn-app-server/api/v2/marketing/christmasActivity`
  );
};
export const getVipConfig = () => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).get(
    `/idn-app-server/api/vip/v1/getVipConfig`
  );
};
export const getVipInfo = () => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).get(
    `/idn-app-server/api/vip/v1/getVipInfo`
  );
};
export const getAgreeMent = () => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).get(
    `/idn-app-server/agreement/vip`
  );
};
export const send_code = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    `/idn-app-server/api/v2/verification/send_code/?${qs.stringify(form)}`
  );
};
export const verifySmsCodeV2 = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    `/idn-app-server/api/v2/verifySmsCode`,
    form
  );
};
export const checkMobileUser = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).get(
    `/idn-app-server/api/v2/users/check/?${qs.stringify(form)}`
  );
};
export const getMyVipDetailPage = () => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    `/idn-app-server/api/vip/getMyVipDetailPage`
  );
};
export const getVipIntroductionPage = data => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    `/idn-app-server/api/vip/getVipIntroductionPage`,
    data
  );
};

export const registerUser = form => {
  const params = JSON.parse(JSON.stringify(form));
  const { google_client_id, attributionInfoJson } = form;
  delete params.google_client_id;
  delete params.attributionInfoJson;
  let option = {
    baseURL: process.env.VUE_APP_URL_LINK,
    versionName: "2.7.0"
  };
  if (google_client_id) {
    option.google_client_id = google_client_id;
  }
  if (attributionInfoJson.advertisingPlatform) {
    option.attributionInfoJson = attributionInfoJson;
  }
  return https(option).post(
    `/idn-app-server/api/v2/users/?${qs.stringify(params)}`
  );
};
export const queryH5SourceConfig = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    `/idn-app-server/api/v2/queryH5SourceConfig?${qs.stringify(form)}`
  );
};
export const thirdpartList = () => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).get(
    `/idn-app-server/api/v2/thirdpart/access/?${qs.stringify({
      app_version: Store.state.appVersion
    })}`
  );
};
export const send_email_code = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    `/idn-app-server/api/v2/verification/send_email_code/?${qs.stringify(form)}`
  );
};
export const verify_job_email = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).patch(
    `/idn-app-server/api/v3/credit/user-job/verify-job-email`,
    form
  );
};
export const ossUploadSignature = form => {
  return https({ baseURL: process.env.VUE_APP_URL_LINK }).post(
    `/idn-app-server/api/v4/credit/user-job/oss-upload-signature`,
    form
  );
};
export const userJobV4 = form => {
  return https({
    baseURL: process.env.VUE_APP_URL_LINK
  }).post(`/idn-app-server/api/v4/credit/user-job`, {
    ...form,
    client_source: Store.state.clientSource
  });
};
